import { VehicleSearchDTO, VehicleSearchResults } from "./vehicleSearch.type";
import getPageLinkType from "./getPageLinkType";
import getPageLinkAndRel from "./getPageLinkAndRel";

export const processSearchResults = ({
  totalResults,
  totalTracked,
  numberOfPages,
  links,
  sortOptions,
  items,
  degradedServices,
  displayFlags,
}: VehicleSearchDTO): VehicleSearchResults => {
  return {
    totalResults,
    totalTracked,
    numberOfPages,
    selfPageUrl: getPageLinkType("self", links) || null,
    firstPageUrl: getPageLinkType("firstPage", links) || null,
    lastPageUrl: getPageLinkType("lastPage", links) || null,
    nextPageUrl: getPageLinkType("next", links) || null,
    currentBidsUrl: getPageLinkType("currentBids", links) || null,
    exportAllUrl: getPageLinkAndRel("exportAll", links) || null,
    printAllUrl: getPageLinkAndRel("printAll", links) || null,
    trackedVehiclesWithGuidePricingUrl:
      getPageLinkAndRel("trackedVehiclesWithGuidePricing", links) || null,
    exportSelectedUrl:
      getPageLinkAndRel("exportSelectedVehicles", links) || null,
    printSelectedUrl: getPageLinkAndRel("printSelectedVehicles", links) || null,
    sortOptions,
    items,
    links,
    degradedServices,
    displayFlags,
  };
};
